// Kleine, fokussierte Utilities für Chat/Sidebar

/** "Heute" => HH:MM, "Gestern" => "Gestern", sonst dd.mm.[yyyy] */
export function formatStamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();

  const isToday = d.toDateString() === now.toDateString();
  const y = new Date(now); y.setDate(now.getDate() - 1);
  const isYesterday = d.toDateString() === y.toDateString();

  if (isToday) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  if (isYesterday) return "Gestern";
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: d.getFullYear() !== now.getFullYear() ? "numeric" : undefined
  });
}

export function previewText(text, max = 40) {
  if (!text) return "";
  return text.length > max ? text.slice(0, max) + "..." : text;
}

/**
 * Baut die Liste für die Sidebar auf – inklusive "System".
 * Erwartet:
 * - conversations: rohe Serverkonversationen
 * - user: aktueller Nutzer
 * - systemMeta: { lastMessageAt, lastMessage, unread }
 */
export function buildConversationList(conversations, user, systemMeta) {
  const meId = Number(user?.id);

  const mapped = (conversations || []).map((c) => {
    const lastTs = c.lastMessageAt ? new Date(c.lastMessageAt).valueOf() : 0;
    const isUnread =
      c.lastMessage && !c.lastRead && Number(c.lastSenderId) !== meId;

    return {
      ...c,
      displayName: c.displayName || c.username,
      avatarUrl: c.avatarUrl || "/apn-logo.png",
      isUnread,
      preview: previewText(c.lastMessage),
      _sortTs: lastTs,
    };
  });

  // System „Konversation“ (Meta kommt aus eigenem Request)
  const sysTs = systemMeta?.lastMessageAt
    ? new Date(systemMeta.lastMessageAt).valueOf()
    : 0;

  const systemItem = {
    userId: "system",
    username: "System",
    displayName: "Systemnachrichten",
    avatarUrl: "/apn-logo.png",
    lastMessage: systemMeta?.lastMessage || "",
    lastMessageAt: systemMeta?.lastMessageAt || null,
    lastSenderId: "system",
    lastDelivered: true,
    lastRead: !systemMeta?.unread, // falls du Unread-Status für System führst
    isUnread: !!systemMeta?.unread,
    preview: previewText(systemMeta?.lastMessage || ""),
    _sortTs: sysTs,
  };

  return [...mapped, systemItem].sort((a, b) => b._sortTs - a._sortTs);
}
